import React, { ComponentProps, useState } from 'react'

import cn from '@/utilities/cn'

type ImageProps = {
  fallbackImage?: React.ReactNode
  loadingImage?: React.ReactNode
}
export default function Image({
  fallbackImage,
  loadingImage,
  src,
  alt,
  className,
  ...rest
}: ImageProps & ComponentProps<'img'>) {
  const [status, setStatus] = useState<'loading' | 'loaded' | 'loaded-with-error'>('loading')
  return (
    <>
      {status === 'loaded-with-error' && fallbackImage}
      {status === 'loading' && loadingImage}
      {(status !== 'loaded-with-error' || (status === 'loaded-with-error' && !fallbackImage)) && (
        <img
          onLoad={() => setStatus('loaded')}
          onError={() => setStatus('loaded-with-error')}
          src={src}
          alt={alt}
          className={cn({ hidden: status === 'loading' }, className)}
          {...rest}
        />
      )}
    </>
  )
}
